import Player from "@vimeo/player"

let tag = document.createElement("script")
let category = 'Video'
let action = 'Video'

tag.src = "https://www.youtube.com/iframe_api"
let firstScriptTag = document.getElementsByTagName("script")[0]
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

let player

function trackVideo(action, website, id) {

  track("Video", action, {
    video: {'page-position': 'Body', id, website},
  })
}

function trackYoutubeVideoProgress(video, website, id) {
  if (!video.getCurrentTime || !video.getDuration) return

  const currentTime = video.getCurrentTime()
  const duration = video.getDuration()
  const watched = Math.floor((currentTime / duration) * 100)

  const videoAction = action + ` Watched ${watched}%`

  trackVideo(videoAction, website, id)
}

function onYouTubeIframeAPIReadyCustom(youtubeVideoID, videoEmbedID) {
  player = new YT.Player(videoEmbedID, {
    height: "100%",
    width: "100%",
    videoId: youtubeVideoID,
    host: "https://www.youtube.com",
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerStateChange,
    },
    playerVars: {
      autoplay: 1,
      controls: 1,
      autohide: 1,
      enablejsapi: 1,
      rel: 0,
      wmode: "opaque",
    },
  })
}

let youtube_id = $(this).attr("data-youtube")
var totalViewedTime = 0,
  startTime = 0,
  endTime = 0,
  totalViewedTimeSec = 0
var l = 0
var percent = 0
function onPlayerReady(event) {
  track("Video", "Loaded", {video: {"page-position": "Body", id: youtube_id, website: "youtube"}})
  if ($(window).width() < 992) {
    event.target.playVideo()
  }
}

function onPlayerStateChange(event) {
  const id = $(this).attr('data-youtube')
  const website = 'youtube'

  if (event.data == YT.PlayerState.ENDED) {
    $('.video-content').removeClass('show')
    event.target.destroy()
    trackYoutubeVideoProgress(event.target, website, id)
  } else if (event.data === 1) {
    trackVideo(action + ' Played', website, id)
  } else if (event.data === 2) {
    trackVideo(action + ' Paused', website, id)
    trackYoutubeVideoProgress(event.target, website, id)
  }
}

function vimeoPlayModal(vimeoVideoID, videoEmbedID) {
  const vimeoID = vimeoVideoID
  const player = new Player(videoEmbedID, {
    id: vimeoVideoID,
    autoplay: true,
  })

  player.on("play", function () {
    trackVideo(action + ' Played', website, vimeoID)
  })
  player.on("loaded", function () {
    track("Video", "Loaded", {video: {"page-position": "Body", id: vimeoID, website: "vimeo"}})
  })
  player.on("pause", function (data) {
    trackVideo(action + ' Paused', website, vimeoID)
    trackVideo(action + ` Watched ${Math.floor(data.percent * 100)}%`, website, vimeoID)
  })

  player.on('ended', function (data) {
    trackVideo(action + ' Paused', website, vimeoID)
    trackVideo(action + ` Watched ${Math.floor(data.percent * 100)}%`, website, vimeoID)
  })
}
function youkuPlayModal(youkuVideoID, videoEmbedID) {
  player = new YKU.Player(videoEmbedID, {
    client_id: "7a0aef3c0f591880",
    vid: youkuVideoID,
    autoplay: true,
    show_related: false,
    events: {
      onPlayerReady: onYoukuPlayerReady,
      onPlayStart: function (event) {},
      onPlayEnd: onPlayEnd,
    },
  })

  var isready = false
  function onYoukuPlayerReady(elm) {
    isready = true
    track("Video", "Loaded", {video: {"page-position": "Body", id: youkuVideoID, website: "youku"}}, elm)
  }

  function onPlayEnd() {
    console.log("Finished")
  }
}
$(document).on("click", ".video-content", function (event) {
  let target = $(event.target)

  let youtubeVideoID = target.data("youtube")
  let vimeoVideoID = target.data("vimeo")
  let youkuVideoID = target.data("youku")
  let videoEmbedID = target.data("id")

  category = target.data('category')

  console.log(videoEmbedID)
  if (youtubeVideoID) {
    onYouTubeIframeAPIReadyCustom(youtubeVideoID, videoEmbedID)

    return
  }
  if (vimeoVideoID) {
    vimeoPlayModal(vimeoVideoID, videoEmbedID)

    return
  }
  if (youkuVideoID) {
    youkuPlayModal(youkuVideoID, videoEmbedID)
    return
  }
})

$(".video-embed").on("click", function () {
  $(this).addClass("show")
})

window.onYouTubeIframeAPIReadyCustom = onYouTubeIframeAPIReadyCustom
window.vimeoPlayModal = vimeoPlayModal
window.youkuPlayModal = youkuPlayModal
